import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { buildSessionReport, dateTime, loadReportLogo, money, reportColors, reportFilename } from './posSessionReport';

/** Un mismo informe para el historial de sesiones y la configuración del POS. */
export async function generarPDFReporteSesionPOS(data: any) {
    const report = buildSessionReport(data);
    const { session, sections } = report;
    const logo = await loadReportLogo();
    const doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });
    const width = doc.internal.pageSize.getWidth();
    const height = doc.internal.pageSize.getHeight();
    const margin = 16;
    const usable = width - margin * 2;
    const rgb = (hex: string): [number, number, number] => [parseInt(hex.slice(0, 2), 16), parseInt(hex.slice(2, 4), 16), parseInt(hex.slice(4, 6), 16)];
    let y = 43;
    const text = (value: string, x: number, atY: number, size = 10, bold = false) => {
        doc.setFont('helvetica', bold ? 'bold' : 'normal');
        doc.setFontSize(size); doc.setTextColor(30, 41, 59);
        doc.text(value, x, atY);
    };
    text('PUNTO DE VENTA Y SESIÓN', margin, y, 8, true);
    text(String(session.punto_de_venta_nombre || session.punto_de_venta || '-'), margin, y + 6, 11, true);
    text(String(session.codigo || session.id || '-'), margin, y + 12);
    text('Sucursal: ' + String(session.sucursal_nombre || '-'), margin, y + 18);
    text('RESPONSABLE Y PERIODO', 155, y, 8, true);
    text('Responsable: ' + String(session.usuario_nombre || session.usuario || '-'), 155, y + 6);
    text('Apertura: ' + dateTime(session.fecha_apertura), 155, y + 12);
    text('Cierre: ' + (report.closed ? dateTime(session.fecha_cierre) : 'Pendiente - sesión abierta'), 155, y + 18);
    const cards = [
        ['SALDO INICIAL', money(report.initial)],
        ['SALDO REGISTRADO', money(report.registered)],
        ['CIERRE DEFINITIVO', report.final == null ? 'Pendiente' : money(report.final)],
        ['PAGOS REGISTRADOS', money(report.totalPayments)],
    ];
    const cardWidth = (usable - 18) / 4;
    cards.forEach(([label, value], index) => {
        const x = margin + index * (cardWidth + 6);
        doc.setFillColor(248, 250, 252); doc.setDrawColor(226, 232, 240);
        doc.roundedRect(x, 72, cardWidth, 23, 2, 2, 'FD');
        doc.setFillColor(...rgb(reportColors[index])); doc.rect(x, 72, 2, 23, 'F');
        text(label, x + 6, 80, 8, true); text(value, x + 6, 89, 13, true);
    });
    y = 103;
    sections.forEach((section, index) => {
        if (index === 1 || y > height - 50) { doc.addPage(); y = 43; }
        text(section.title, margin, y, 12, true);
        const body = section.rows.length ? section.rows.map(row => row.map((cell, col) =>
            section.moneyColumns?.includes(col) && typeof cell === 'number' ? money(cell) : cell
        )) : [['Sin registros en esta sesión', ...section.headers.slice(1).map(() => '')]];
        const columnStyles: any = {};
        section.moneyColumns?.forEach(col => { columnStyles[col] = { halign: 'right', cellWidth: section.headers.length > 4 ? 29 : 55 }; });
        if (section.headers.length === 7) {
            columnStyles[0] = { cellWidth: 48 }; columnStyles[1] = { cellWidth: 60 };
            columnStyles[2] = { cellWidth: 40 }; columnStyles[3] = { cellWidth: 30 };
        }
        autoTable(doc, {
            startY: y + 5, head: [section.headers], body,
            margin: { left: margin, right: margin, top: 43, bottom: 20 },
            theme: 'plain', showHead: 'everyPage', rowPageBreak: 'avoid',
            styles: { fontSize: 9, cellPadding: index === 0 ? 2 : 2.5, textColor: [30, 41, 59], overflow: 'linebreak', valign: 'middle' },
            headStyles: { fillColor: [0, 127, 200], textColor: [255, 255, 255], fontStyle: 'bold', fontSize: 9 },
            alternateRowStyles: { fillColor: [245, 248, 252] }, columnStyles,
        });
        y = (doc as any).lastAutoTable.finalY + 12;
    });
    const pageCount = doc.getNumberOfPages();
    for (let page = 1; page <= pageCount; page++) {
        doc.setPage(page);
        if (logo) doc.addImage(logo, 'PNG', width - margin - 25, 5, 25, 25);
        text('CO MARCA GROUP', margin, 14, 10, true);
        text('Reporte de sesión POS · ' + report.typeLabel, margin, 23, 18, true);
        text((report.closed ? 'SESIÓN CERRADA' : 'SESIÓN ABIERTA - INFORME PROVISIONAL') + '  |  ' + String(session.codigo || session.id || '-'), margin, 30, 9);
        reportColors.forEach((hex, i) => {
            doc.setFillColor(...rgb(hex)); doc.rect(margin + i * usable / 4, 35, usable / 4, 1.2, 'F');
        });
        doc.setDrawColor(226, 232, 240); doc.line(margin, height - 14, width - margin, height - 14);
        text('Caja = saldo inicial + entradas - salidas. Los pagos bancarios no se suman a la caja.', margin, height - 9, 8);
        doc.setFontSize(8);
        doc.text('Página ' + page + ' de ' + pageCount, width - margin, height - 9, { align: 'right' });
    }
    doc.save(reportFilename(session, 'pdf'));
    return doc;
}
